import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const BackgroundCheckList = lazy(() =>
    import(/* webpackChunkName: "BackGroundLIST" */ './BackgroundCheckList').then( async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        // Only show My Loan List page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('backgroundcheckList', reducer.listReducer);
            return module;
        }
    })
);

const BackgroundCheckDetail = lazy(() =>
    import(/* webpackChunkName: "loanDetail" */ './BackgroundCheckDetail').then(async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        // Only show My Loan Detail page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('backgroundcheckDetail', reducer.detailReducer);
            return module;
        }
    })
);

const BackgroundCheckRoutes = [
    {
        label: 'Background Check',
        path: '/HRAutomation/BackgroundCheck',
        menuName: 'BackgroundCheck',
        component: BackgroundCheckList,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Background Check',
        path: '/HRAutomation/BackgroundCheck/:id/:mode',
        component: BackgroundCheckDetail,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
]

export default BackgroundCheckRoutes;